import React from 'react';
import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';

import UserCard from '@apps/shared/src/auth/UserCard';

const styles = () => ({
  content: {
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    height: 'calc(100vh - 120px)',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      height: 'auto',
    },
  },
});

export function Welcome({ classes }) {
  return (
    <div className={classes.content}>
      <UserCard title="Welcome!" showLogo>
        <Typography variant="h5">Welcome to MediVI</Typography>
        <Link to="/">MediVI Web</Link>
      </UserCard>
    </div>
  );
}

Welcome.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default withStyles(styles)(Welcome);
